import { EntryRequest } from 'modules/teams/domain/interfaces/entry-request';
import { EntryRequestResponseDto, EntryRequestUserDto } from 'modules/teams/domain/interfaces/response-dto';
import { TeamParticipant } from 'modules/teams/domain/interfaces/team-participant';

export function mapEntryRequestUserDto(user: EntryRequestUserDto): TeamParticipant {
  return {
    id: user.id,
    name: user.name ?? '',
    surname: user.surname ?? '',
    middleName: user.middleName,
    birthDate: user.birthDate,
    height: user.height,
    weight: user.weight,
    // Без фото — без `photo`: заглушку подставляет отрисовка, иначе она уходит в данные как фото участника.
    photo: user.photo?.externalUrl ? { id: user.photo.id ?? 0, externalUrl: user.photo.externalUrl } : undefined,
    createdAt: user.createdAt,
  };
}

export function mapEntryRequestDto(entryRequest: EntryRequestResponseDto): EntryRequest {
  return {
    id: entryRequest.id,
    status: entryRequest.status,
    createdAt: entryRequest.createdAt,
    user: mapEntryRequestUserDto(entryRequest.requestingUser),
  };
}
